'use strict';

import {Injectable} from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    CanLoad,
    Route
} from '@angular/router';
import {AuthService} from "./auth.service";
import {AppConfigs} from "../../app.config";
import {AuthenticationService} from "../authentication.service";

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {

    constructor(private authService: AuthService,
                private router: Router,
                private authenticationService: AuthenticationService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let url: string = state.url;

        return this.checkLogin(url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        // redirect [AppConfigs.URL_USER_NOT_CONNECT] with USER not connected or unfriend line bot
        let existUserConnect = this.authenticationService.getFieldUserCurrent('existUserConnect');
        let connectTwitter = this.authenticationService.getFieldUserCurrent('connectTwitter');
        let roleUserDeny = route.data.existConnect;
        let path = route.data.path;
        let roleDenyConnectLine = AppConfigs.ACL_CONNECT_LINE;
        let roleDenyConnectTwitter = AppConfigs.ACL_CONNECT_TWITTER;

        if (
            (existUserConnect == false || existUserConnect == null)
            && typeof roleUserDeny !== "undefined"
            && roleDenyConnectLine.indexOf(roleUserDeny) !== -1
        ) {
            this.router.navigate([AppConfigs.URL_USER_NOT_CONNECT]);
            return true;
        }

        //Check for twitter
        if (
            typeof path !== "undefined" && path == "twitter"
            && (connectTwitter == false || connectTwitter == null)
            && roleDenyConnectTwitter.indexOf(roleUserDeny) !== -1
        ) {
            this.router.navigate([AppConfigs.URL_USER_NOT_CONNECT]);
            return true;
        }

        return this.canActivate(route, state);
    }

    canLoad(route: Route): boolean {
        let url = `/${route.path}`;

        return this.checkLogin(url);
    }

    checkLogin(url: string): boolean {
        if (this.authService.isLoggedIn || this.authService.isAuthenticated()) {
            return true;
        }

        this.authService.redirectUrl = url ? url : '/';

        this.router.navigate(['/login']);
        return false;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/auth/auth-guard.service.ts